import {
  Alert,
  Box,
  Button,
  Container,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { PostLogin } from "src/apis/auth";
import { storeToken } from "src/utils/auth";
import { AuthContext } from "src/context/AuthContext";
import { useNavigate } from "react-router-dom";

export function Login() {
  const { setAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [hasError, setHasError] = useState<boolean>(false);

  async function onSubmit() {
    setHasError(false);

    try {
      const resp = await PostLogin({ username, password });
      setAuthenticated(true);
      storeToken(resp.data.token);
      navigate("/");
    } catch (err) {
      setHasError(true);
    }
  }

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "85vh",
        textAlign: "center",
        // backgroundColor: "#ffe7db",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "90%",
          maxWidth: "400px",
          borderRadius: "16px",
          padding: "40px",
          paddingBottom: "30px",
          gap: "3rem",
        }}
      >
        <Typography fontSize={40} fontFamily="monospace" fontWeight={600}>
          Eezycare
        </Typography>

        <FormControl
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          {hasError && (
            <Alert severity="error">
              Falha ao conectar, por favor verifique seu email e senha e tente novamente
            </Alert>
          )}
          <TextField
            id="email"
            label="Email"
            fullWidth
            type={"email"}
            onChange={(e) => setUsername(e.target.value)}
            required
            InputLabelProps={{ required: false }}
          />
          <TextField
            id="password"
            label="Senha"
            fullWidth
            type={"password"}
            onChange={(e) => setPassword(e.target.value)}
            required
            InputLabelProps={{ required: false }}
          />
          <Button
            variant="contained"
            type="submit"
            sx={{
              width: "100%",
              height: '56px'
            }}
            disabled={!username || !password}
          >
            Entrar
          </Button>
          <Button
            variant="text"
            type="button"
            onClick={() => {
              if (window.confirm("Deseja prosseguir para a recuperação de acesso?")) {
                navigate("/esqueci-minha-senha");
              }
            }}
          >
            Esqueci minha senha
          </Button>
        </FormControl>
      </Box>
    </Container>
  );
}
